export function pFileReader (file) {
  return new Promise((resolve, reject) => {
    var fr = new FileReader()
    fr.onload = resolve // CHANGE to whatever function you want which would eventually call resolve
    fr.onerror = reject
    // fr.onprogress = progress
    // fr.readAsArrayBuffer(file)
    fr.readAsBinaryString(file)
  })
}

export function cargarFile (file) {
  console.debug('file %o ', file)
  return pFileReader(file).then(function (event) {
    console.debug('buffer=%d %o', event.target.result.byteLength, event.target.result)
    // console.log("buffer="+event.target.result.byteLength )
    return event.target.result // returns buffer
  })
}